export default __webpack_public_path__ + "static/outsource@mob_2x-c60c47b37fb6c5bb872e1f18c615ba2f.webp";